import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";

import styles from "./LandlordLanding.module.css";
import { useAuth } from "../../../contexts/AuthContext"; // Import your auth context

function LandlordLanding() {
  const navigate = useNavigate();
  const { userDetails } = useAuth();

  useEffect(() => {
    // Navigate automatically if the user is logged in
    if (userDetails) {
      navigate(`/MyFirstLand?category=listings`);
    }
  }, [userDetails, navigate]);

  const handleSignUp = () => {
    navigate(`/landlord-onbaord`);
  };

  return (
    <div className="primary-wrapper">
      <Navbar />
      <div className="primary-container">
        <div className={styles.bodyContainer}>
          <div>This is a landing page for landlords</div>
          <Button onClick={handleSignUp}>Sign Up</Button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default LandlordLanding;
